/* eslint-disable prefer-template */
import { Component } from '@verndale/core';
import $ from 'jquery';
import 'slick-carousel/slick/slick';

class Module extends Component {
  setupDefaults() {
    this.dom = {};

    this.initCarousel();
  }

  addListeners() {}

  // Code from the original MarineMax repo, just tweaked couple things
  initCarousel() {
    const $modelCallouts = $('section.product-catalog-row');
    if ($modelCallouts.length) {
      $modelCallouts.each((index, el) => {
        const $container = $(el);
        const $slider = $container.find('.product-catalog-row__callouts');
        const $status = $container.find('.product-catalog-row__slide-count');
        const count = $container.data('count');
        const $categoriesSelector = $container.find(
          '.categories-mobile-selector'
        );
        const $categories = $container.find('.product-catalog-row__categories-tablist button');

        if (!count || count <= 1) {
          $container.addClass('no-slider');
          return;
        }

        $slider.on('init reInit afterChange', (event, slick, currentSlide) => {
          // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          const i = (currentSlide || 0) + 1;
          $status.text(
            String('00' + i).slice(-2) +
              ' / ' +
              String('00' + slick.slideCount).slice(-2)
          );
        });

        $slider.slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ],
          nextArrow:
            `<button class="slick-next angle-only">
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27 21.5L18 10L23.625 21.5L18 33L27 21.5Z" fill="#0076a7"/>
                <circle cx="22" cy="22" r="21.5" stroke="#0076a7"/>
                </svg>
              <span class="sr-only">Next Slide</span>
            </button>`,
          prevArrow:
            `<button class="slick-prev angle-only">
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 21.5L27 10L21.375 21.5L27 33L18 21.5Z" fill="#0076a7"/>
                <circle cx="22" cy="22" r="21.5" stroke="#0076a7"/>
                </svg>
              <span class="sr-only">Previous Slide</span>
            </button>`
        });

        function slickCleanup() {
          const slick = $slider.slick('getSlick');
          if (slick.slideCount < slick.options.slidesToShow) {
            $slider.addClass('slick-no-slide');
          } else {
            $slider.removeClass('slick-no-slide');
          }
          if (slick.slideCount <= slick.options.slidesToShow) {
            $status.hide();
          } else {
            $status.show();
          }
        }

        function setActiveCategory($cat) {
          $categories.removeClass('active');
          $cat.addClass('active');
          $categoriesSelector.html($cat.html());
          $slider
            .slick('slickUnfilter')
            .slick('slickFilter', $cat.attr('rel'));
          slickCleanup();
          if ($categoriesSelector.length) {
            $(document).off('click.categoriesChanger');
            $categoriesSelector.removeClass('active');
          }
        }

        $slider.on('breakpoint', () => {
          slickCleanup();
        });

        if ($categories.length) {
          $categoriesSelector.on('click', (e) => {
            if ($categoriesSelector.hasClass('active')) {
              $(document).off('click.categoriesChanger');
              $categoriesSelector.removeClass('active');
            } else {
              $categoriesSelector.addClass('active');
              e.stopPropagation();
              $(document).one(
                'click.categoriesChanger',
                () => {
                  $categoriesSelector.removeClass('active');
                }
              );
            }
          });

          setActiveCategory($categories.first());

          $categories.on('click', () => {
            setActiveCategory($(this));
            slickCleanup();
          });

        } else {
          slickCleanup();
        }

        $container.addClass('ready');
      });
    }
  }
}

export default Module;
